"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonitorStateController = void 0;
/** @internal */
class MonitorStateController {
    constructor(window) {
        // ---------------------------------------------------------------------------
        this.onScreenPropertyChanged = (args) => {
            const { monitor, id } = args;
            if (id !== this.window.Id()) {
                return;
            }
            console.info(`screen changed: ${id}`, monitor);
            this.window.onWindowMonitorPropertyChanged({
                width: monitor.workingArea.width,
                height: monitor.workingArea.height,
                left: monitor.workingArea.left,
                top: monitor.workingArea.top
            }, args.window);
        };
        this.window = window;
        overwolf.windows.onScreenPropertyChanged.addListener(this.onScreenPropertyChanged);
        console.info(`Creating monitor controller for ${this.window.Id()}`);
    }
    // ---------------------------------------------------------------------------
    dispose() {
        console.info(`Disposing of monitor controller for ${this.window.Id()}`);
        overwolf.windows.onScreenPropertyChanged.removeListener(this.onScreenPropertyChanged);
        this.window = null;
    }
}
exports.MonitorStateController = MonitorStateController;
//# sourceMappingURL=monitor_state_controller.js.map